import { useMousetrap }    from 'use-mousetrap'
import { useNavigate }     from 'react-router-dom'
import { useAtom }         from 'state/jotai'
import { close_drawer }    from 'state/actions'
import { vis_compare }     from 'state/store.global'
import { vis_desktop_nav } from 'state/store.global'
import { useToggle } from 'hooks/useToggle'

export const Hotkeys = () => {
  const { toggleOverlay } = useToggle();
  const setComp      = useAtom(vis_compare)[1]
  const setNav       = useAtom(vis_desktop_nav)[1]
  const navigateTo   = useNavigate()

  useMousetrap('q q q', () => alert('q q q') )
  useMousetrap('a a a', () => alert('a a a') )
 
  useMousetrap('1',() => toggleOverlay('filter'))
  useMousetrap('2',() => toggleOverlay('sorter'))
  useMousetrap('3',() => toggleOverlay('detail'))
  useMousetrap('0',() => setNav(a => !a))

  useMousetrap('x',() => navigateTo('/en/list'))
  useMousetrap('c',() => navigateTo('/en/isometry'))
  useMousetrap('v',() => navigateTo('/en/compare'))
  useMousetrap('b',() => navigateTo('/en/gallery'))
  useMousetrap('n',() => navigateTo('/en/downloads'))
  useMousetrap('m',() => navigateTo('/en/airphoto'))
  useMousetrap('å',() => navigateTo('/en/frontpage'))
  useMousetrap('u',() => navigateTo('/en/unit'))

  useMousetrap('esc',() => { 
    toggleOverlay('detail');
    setComp(false)
  })

  return null

}